<template>
  <li :class="['menu-item', claseCss, { active: esActivo }]">
    <i :class="['menu-item-icon', { 'notificaciones-icon': tieneNotificaciones }]">
      <span v-if="tieneNotificaciones" class="status"></span>
    </i>
    <span class="menu-item-text">{{ $t(`menu.item.${texto}`) }}</span>
    <span class="notificaciones-number">{{ numNotificaciones }}</span>
  </li>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  claseCss: string;
  esActivo: boolean;
  texto: string;
  numNotificaciones: number;
}>();

const tieneNotificaciones = computed(() => props.numNotificaciones > 0);
</script>